export class DateFormatUtil {

    static toDisplayFormat(date: Date | string | null): string | null {
        if (!date) return null;

        const d = new Date(date);
        const day = ('0' + d.getDate()).slice(-2);
        const month = ('0' + (d.getMonth() + 1)).slice(-2); 
        const year = d.getFullYear();

        return `${year}-${month}-${day}`;
    }

    // Optional: check if a value is a valid date
    static isValidDate(value: any): boolean {
        return !isNaN(Date.parse(value));
    }
}
